import { convertToSortedOptions } from '@/utils'

export const BUSINESS_TYPE = {
  EPE: { label: 'EPE', value: '1', index: 0 },
  NON_EPE: { label: 'NON-EPE', value: '0', index: 1 }
}
export const BUSINESS_TYPE_OPTIONS = convertToSortedOptions(BUSINESS_TYPE)

export const SALE_TYPE = {
  RETURN: { label: 'Return', value: '0', index: 0 },
  BUY: { label: 'Buy', value: '1', index: 1 }
}
export const SALE_TYPE_OPTIONS = convertToSortedOptions(SALE_TYPE)

export const STATUS_INBOUND = {
  BLANK: { label: '-', value: 'DRAFT', index: 0 },
  WAITING: { label: 'Waiting', value: 'CONFIRMED', index: 1 },
  RECEIVED: { label: 'Received', value: 'RECEIVED', index: 2 },
  RECEIVED_INCOMPLETED: { label: 'Received (Incomplete)', value: 'RECEIVED_INCOMPLETED', index: 3 }
}
export const STATUS_INBOUND_OPTIONS = convertToSortedOptions(STATUS_INBOUND)

export const STATUS_OUTBOUND = {
  NOT_RECEIVED: { label: 'Not Received', value: 'NOT_RECEIVED', index: 0 },
  BLANK: { label: '-', value: 'DRAFT', index: 1 },
  PACKED: { label: 'Packed', value: 'PACKED', index: 2 },
  IN_TRANSIT: { label: 'In Transit', value: 'IN_TRANSIT', index: 3 },
  RECEIVED: { label: 'Received', value: 'RECEIVED', index: 4 },
  RECEIVED_INCOMPLETED: { label: 'Received (Incomplete)', value: 'RECEIVED_INCOMPLETED', index: 5 }
}
export const STATUS_OUTBOUND_OPTIONS = convertToSortedOptions(STATUS_OUTBOUND)

export const STATUS_ORDER_MANAGEMENT = {
  BLANK: { label: '-', value: 'DRAFT', index: 0 },
  SENT: { label: 'Sent', value: 'SENT', index: 1 },
  DONE: { label: 'Done', value: 'DONE', index: 2 }
}
export const STATUS_ORDER_MANAGEMENT_OPTIONS = convertToSortedOptions(STATUS_ORDER_MANAGEMENT)

export const SALE_BY_SUPPLIER_STATUS = {
  ORDER_CREATED: { label: 'Order Created', value: 1, index: 0 },
  ORDER_NOT_CREATED: { label: '-', value: 0, index: 1 }
}
export const SALE_BY_SUPPLIER_STATUS_OPTIONS = convertToSortedOptions(SALE_BY_SUPPLIER_STATUS)

export const STATUS_CUSTOMER_PRODUCT = {
  AVAILABLE: { label: 'Available', value: 'true', index: 0 },
  DISCONTINUED: { label: 'Discontinued', value: 'false', index: 1 }
}
export const STATUS_CUSTOMER_PRODUCT_OPTIONS = convertToSortedOptions(STATUS_CUSTOMER_PRODUCT)

export const STATUS_PRODUCT = {
  ACTIVE: { label: 'Active', value: 'true', index: 0 },
  INACTIVE: { label: 'Inactive', value: 'false', index: 1 }
}
export const STATUS_PRODUCT_OPTIONS = convertToSortedOptions(STATUS_PRODUCT)

export const STATUS_QUANTITY = {
  IN_STOCK: { label: 'In Stock', value: '1', index: 0 },
  OUT_OF_STOCK: { label: 'Out of Stock', value: '0', index: 1 }
}
export const STATUS_QUANTITY_OPTIONS = convertToSortedOptions(STATUS_QUANTITY)

export const IS_ACTIVE = {
  ACTIVE: '1',
  INACTIVE: '0'
} as const

export const IS_ACTIVE_OPTIONS = [
  { label: 'Active', value: IS_ACTIVE.ACTIVE },
  { label: 'Inactive', value: IS_ACTIVE.INACTIVE }
]
